<!--
 * @Description: 秒杀活动不存在
 * @Author: kayvor
 * @Date: 2020-04-01 16:22:13
 * @LastEditTime: 2020-04-20 17:28:36
 * @LastEditors: kayvor
 -->

<template>
    <div class="seckillNoFund-component" :style="{'height': height + 'px'}">
        <i class="ico ico-icon_59"></i>
        <div class="tips">活动不存在</div>
    </div>
</template>

<script >
export default {
    name: 'seckillNoFund',
    data () {
        return {
            height: 0
        }
    },
    created () {

    },
    activated () {

    },
    mounted () {
        const headerHeight = document.querySelector('.componentHeader').clientHeight || 0
        const $height = document.documentElement.clientHeight || document.body.clientHeight
        this.height = $height - headerHeight - 1
    },
}
</script>

<style lang="stylus" scoped>
@import "../../../../assets/stylus/variables";

.seckillNoFund-component
    width 100%
    height 100%
    padding-top 310px
    text-align center
    .tips
        padding-top 40px
        font-size $fontBase
        color $fcGreyish
</style>
